import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap';
// import Floater from 'react-floater';
import TourManagerModal from './TourManagerModalContainer';
import ManageBidFilterDropDown from './ManageBidFilterDropDown';

class ManageBidsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.downloadTourPdf = this.downloadTourPdf.bind(this);
    this.downloadTourXls = this.downloadTourXls.bind(this);
    this.downloadHotelXls = this.downloadHotelXls.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleTourManagerView = this.toggleTourManagerView.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }
  open() {
    this.setState({ showModal: true });
  }
  downloadTourPdf() {
    const payload = { format: 'application/pdf', report: 'tour' };
    this.props.downloadTourPdf(this.props.id, payload);
  }
  downloadTourXls() {
    const payload = { format: 'application/vnd.ms-excel', report: 'tour' };
    this.props.downloadTourPdf(this.props.id, payload);
  }
  downloadHotelXls() {
    const payload = { format: 'application/vnd.ms-excel', report: 'hotel' };
    this.props.downloadTourPdf(this.props.id, payload);
  }

  toggleTourManagerView() {
    this.props.setTourManagerSimMode(this.props.isTourManager);
  }
  handleSubmit(values) {
    this.props.sendToTourManager(this.props.id, values);
    this.close();
  }
  render() {
    const readOnlyOrTourManager = this.props.readOnly || this.props.isTourManager;
    const downloadTitle = (
      <span>
        <i className="fa fa-download" aria-hidden="true" /> Download
      </span>
    );
    return (
      <div>
        {!readOnlyOrTourManager && (
          <ButtonGroup>
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.open}
              title="Share with Collaborator"
            >
              <i className="fa fa-share-alt" aria-hidden="true" /> Share
            </Button>
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.toggleTourManagerView}
              title="See what Collaborators can do in Catch"
            >
              <i className="fa fa-eye" aria-hidden="true" /> Preview Collaborator View
            </Button>
          </ButtonGroup>
        )}
        <DropdownButton title={downloadTitle} id="bg-nested-dropdown" bsStyle="info">
          <MenuItem
            id={this.props.id}
            bsStyle="info"
            onClick={this.downloadTourPdf}
            title="Download Travel Itinerary and Hotels as PDF"
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true" /> Itinerary
          </MenuItem>
          <MenuItem
            id={this.props.id}
            bsStyle="info"
            onClick={this.downloadTourXls}
            title="Download Travel Itinerary and Hotels as Excel"
          >
            <i className="fa fa-file-excel-o" aria-hidden="true" /> Itinerary
          </MenuItem>
          <MenuItem divider />
          <MenuItem
            id={this.props.id}
            bsStyle="info"
            onClick={this.downloadHotelXls}
            title="Download Hotel Options as Excel"
          >
            <i className="fa fa-file-excel-o" aria-hidden="true" /> Hotel Options
          </MenuItem>
        </DropdownButton>
        <a id="pdf-link" />
        <ButtonGroup className="pull-right">
          {!readOnlyOrTourManager && (
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.props.showUpdate}
              title="Send update to selected hotels"
            >
              <i className="fa fa-commenting" aria-hidden="true" /> Send Update
            </Button>
          )}
          <ManageBidFilterDropDown
            groups={this.props.groups}
            filter={this.props.filter}
            bidFilterSet={this.props.bidFilterSet}
          />
        </ButtonGroup>
        {this.state.showModal && (
          <TourManagerModal
            show={this.state.showModal}
            onClose={this.close}
            readOnly={this.props.readOnly}
          />
        )}
      </div>
    );
  }
}

ManageBidsMenu.propTypes = {
  id: PropTypes.number.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  isTourManager: PropTypes.bool,
  sendToTourManager: PropTypes.func.isRequired,
  downloadTourPdf: PropTypes.func.isRequired,
  setTourManagerSimMode: PropTypes.func.isRequired,
  messageSet: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  filter: PropTypes.object,
  bidFilterSet: PropTypes.func.isRequired,
  showUpdate: PropTypes.func.isRequired,
};

ManageBidsMenu.defaultProps = {
  isTourManager: true,
};
export default ManageBidsMenu;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBidsMenu.js